import { IAppConfig, IUserFromAD } from '../types';
import { handleJsonResponse } from './fetchHelpers';
import URI from 'urijs';

export function findUserRequest(
  { treatCanaryApiUrl }: IAppConfig,
  userName: string,
): Promise<IUserFromAD[]> {
  return handleJsonResponse(
    fetch(
      URI(treatCanaryApiUrl)
        .segment('users')
        .query({
          search: userName,
        })
        .toString(),
      {
        method: 'GET',
      },
    ),
  );
}
